var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('polaris-page-header', {
    attrs: {
      "title": _vm.title,
      "icon": _vm.icon,
      "breadcrumbs": _vm.breadcrumbs,
      "separator": _vm.separator,
      "primary-action": _vm.primaryAction,
      "secondary-actions": _vm.secondaryActions,
      "pagination": _vm.pagination,
      "action-groups": _vm.actionGroups
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Page__Content"
  }, [_vm._t("default")], 2)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3edb4e6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3edb4e6e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPage.vue
// module id = 214
// module chunks = 0